module.exports = __webpack_public_path__ + "img/11.9ffb7d10.jpg";